var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-dropdown", [_c("div", {
    staticClass: "boxHover locale"
  }, [_c("a-icon", {
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      type: "global"
    }
  }), _vm.islogin ? _c("span", {
    staticStyle: {
      "margin-left": "5px",
      width: "95px"
    }
  }, [_vm._v(_vm._s(_vm.currentName))]) : _vm._e()], 1), _c("a-menu", {
    attrs: {
      slot: "overlay"
    },
    on: {
      click: _vm.changeLocale
    },
    slot: "overlay",
    model: {
      value: _vm.modelValue,
      callback: function ($$v) {
        _vm.modelValue = $$v;
      },
      expression: "modelValue"
    }
  }, _vm._l(_vm.localeList, function (item) {
    return _c("a-menu-item", {
      key: item.key
    }, [_c("span", [_vm._v(_vm._s(item.name))])]);
  }), 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };